import { render } from "./KofiErfassungModulWizard.pug?vue&type=template&id=5e2a77c3&lang=pug"
import script from "./KofiErfassungModulWizard.js?vue&type=script&lang=js"
export * from "./KofiErfassungModulWizard.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__